import React from 'react';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import InputField from 'components/v2/input-field/input-field';

const LocationNotesField = props => {
  const { initialValue, ...other } = props;
  return (
    <InputField
      {...other}
      placeholder={I18n.t(
        'shopify.settings.addressSettingsSection.form.placeholder.locationNotes',
      )}
      fieldOptions={{
        initialValue,
      }}
    />
  );
};

LocationNotesField.propTypes = {
  id: PropTypes.string.isRequired,
  form: PropTypes.shape({}).isRequired,
  initialValue: PropTypes.string,
  disabled: PropTypes.bool,
};

LocationNotesField.defaultProps = {
  initialValue: '',
  disabled: false,
};

export default LocationNotesField;
